<mat-sidenav-container [autosize]="isAutoSize">
  <!-- Side Menu-->
  <mat-sidenav
    [ngClass]="{shrink: (isSmall$ | async)}"
    #snav
    [opened]="isOpen$ | async"
    [mode]="navMode$ | async"
    [autoFocus]="false"
    [disableClose]="true"
    (closedStart)="sideNavClosed()"
    (mouseenter)="mouseOverSideBar()"
    (mouseleave)="mouseOutSideBar()"
  >
    <div class="side-nav-wrapper">
      <!-- Upper Left Menu-->
      <div>
        @if ((showMobileMenuIcon$ | async) !== true) {
          <div
            class="shrink-icon"
            (click)="toggleShrinkMenu()"
            [ngClass]="{shrink: isShrinkMode$ | async}"
          >
            <em-button
              type="icon"
              color="basic"
              class="icon-open"
              icon="keyboard_double_arrow_right"
            ></em-button>
            <em-button
              type="icon"
              color="basic"
              class="icon-close"
              icon="keyboard_double_arrow_left"
            ></em-button>
          </div>
        }
        <a class="logo-link" [routerLink]="['/']">
          <img [src]="logoUrl$ | async" />
        </a>
        <mat-nav-list>
          @for (item of mainItemsObservable$ | async; track item.title) {
            <em-nav-item
              [item]="item"
              [hideNested]="isSmall$ | async"
              (itemClicked)="menuItemClicked()"
            ></em-nav-item>
          }
        </mat-nav-list>
      </div>
      <!-- Lower Left Menu-->
      <div class="side-bottom-menu">
        <em-country-selection></em-country-selection>

        <em-button
          color="basic"
          type="link"
          icon="help_outline"
          linkUrl="https://support.emarketing.com"
          linkTarget="_blank"
        >
          <span class="btn-label">{{ 'NAV_SUPPORT' | translate }}</span>
        </em-button>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content id="scrollable-content">
    <!-- Top Menu-->
    <mat-toolbar>
      @if (showMobileMenuIcon$ | async) {
        <em-button
          class="mobile-menu-icon"
          type="icon"
          color="basic"
          icon="menu"
          (click)="toggleMenu()"
        >
        </em-button>
      }
      <!-- Header part will display the router outlet 'header' if provided or default title-->
      @if ((headerOutletActive$ | async) !== true) {
        @if (activeItem$ | async; as activeItem) {
          @if (activeItem.iconImage) {
            <img class="header-icon" [src]="activeItem.iconImage" />
          }
          {{ activeItem.pageTitle || activeItem.title | translate }}
        }
      }
      <router-outlet
        name="header"
        (activate)="headerOutletActive(true)"
        (deactivate)="headerOutletActive(false)"
      ></router-outlet>
      <span class="spacer"></span>
      @if (isAdmin()) {
        <small class="mr-4 text-sm">{{ merchant()?.uuid }}</small>
        <em-icon-button
          color=""
          icon="lab_panel"
          matTooltip="Open In Staging"
          (btnClick)="goToStaging()"
        ></em-icon-button>
        <em-icon-button
          color=""
          icon="engineering"
          matTooltip="Admin Panel"
          [routerLink]="['admin']"
        ></em-icon-button>
      }
      <em-user-menu icon="account_circle" [menuItems]="userMenuItems$ | async">
        <ng-container header>
          <div class="user-info-wrapper">
            @if (merchant()?.firstName || merchant()?.lastName) {
              <div class="user-name">
                {{ merchant()?.firstName + ' ' + merchant()?.lastName }}
              </div>
            }
            @if (merchant()?.email) {
              <small class="user-email">{{ merchant()?.email }}</small>
            }
          </div>
          <mat-divider></mat-divider>
        </ng-container>
        <mat-divider></mat-divider>
        <button mat-menu-item class="logout-btn" (click)="logout()">
          <mat-icon class="!text-danger-500">power_settings_new</mat-icon>
          <span class="text-danger-500">{{
            'ACTIONS_LOGOUT' | translate
          }}</span>
        </button>
      </em-user-menu>
    </mat-toolbar>

    <!-- Actual Conten of the page-->
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
